import {
  FETCH_PHONE_SERVICE,
  SUBMIT_PHONE_SERVICE,
  DELETE_PHONE_SERVICE,
  REFRESH_PHONE_SERVICE_DATATABLES,
  RESET_STORE,
} from '../actions/_types';

const initialState = {
  result: [],
  submitResult: {},
  deleteResult: {},

  refresh: false,
};

export default function phoneService(state = initialState, action) {
  switch (action.type) {
    case FETCH_PHONE_SERVICE:
      return {
        ...state,
        result: action.result,
      };

    case SUBMIT_PHONE_SERVICE:
      return {
        ...state,
        submitResult: action.result,
      };

    case DELETE_PHONE_SERVICE:
      return {
        ...state,
        deleteResult: action.result,
      };

    case REFRESH_PHONE_SERVICE_DATATABLES:
      return {
        ...state,
        refresh: !state.refresh,
      };

    case RESET_STORE:
      return { ...initialState };

    default:
      return state;
  }
}
